import { Link } from 'react-router-dom';
import {
  XMarkIcon,
  ArrowRightOnRectangleIcon,
  UserPlusIcon,
  InformationCircleIcon,
  PhoneIcon,
  HomeIcon,
  ClipboardDocumentListIcon,
  BriefcaseIcon,
} from '@heroicons/react/24/outline';

const menuLinks = [
  { label: 'Home', to: '/', icon: HomeIcon },
  { label: 'Records', to: '/records', icon: ClipboardDocumentListIcon },
  { label: 'Disbursements', to: '/projects', icon: BriefcaseIcon },
  { label: 'About', to: '/about', icon: InformationCircleIcon },
  { label: 'Contact', to: '/contact', icon: PhoneIcon },
];

function MobileNavDrawer({ isOpen, onClose, user, onLogout }) {
  return (
    <div className={`xl:hidden fixed inset-0 z-40 ${isOpen ? '' : 'pointer-events-none'}`}>
      {/* Dimmed backdrop, closes the menu on click */}
      <div
        className={`absolute inset-0 bg-black/70 transition-opacity duration-300 ${
          isOpen ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={onClose}
      />
      {/* Drawer panel, slides in from the right */}
      <div
        className={`absolute top-0 right-0 h-full w-64 bg-navy shadow-xl flex flex-col transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Drawer header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <h2 className="text-xl font-semibold text-white">Welcome!</h2>
          <button
            type="button"
            onClick={onClose}
            className="p-1 text-white"
            aria-label="Close menu"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Drawer nav links */}
        <nav className="flex flex-col px-5 py-3">
          {menuLinks.map(({ label, to, icon: Icon }) => (
            <Link
              key={label}
              to={to}
              onClick={onClose}
              className="flex items-center gap-3 py-5 text-md font-medium text-white hover:text-gold transition border-b border-white/5"
            >
              <Icon className="h-6 w-6" />
              {label}
            </Link>
          ))}
        </nav>

        {/* Login/Sign Up buttons, or Logout when signed in, pinned to the bottom */}
        <div className="mt-auto px-5 pb-3 space-y-2">
          {user ? (
            <button
              type="button"
              onClick={onLogout}
              className="flex w-full items-center justify-center gap-2 rounded-full border border-danger/60 py-3 text-md font-bold text-danger transition hover:bg-danger/10"
            >
              <ArrowRightOnRectangleIcon className="h-6 w-6" />
              Logout
            </button>
          ) : (
            <>
              <Link
                to="/login"
                onClick={onClose}
                className="flex w-full items-center justify-center gap-2 rounded-full border border-white/30 py-3 text-md font-bold text-white transition hover:bg-white/10"
              >
                <ArrowRightOnRectangleIcon className="h-5 w-5" />
                Login
              </Link>
              <Link
                to="/signup"
                onClick={onClose}
                className="flex w-full items-center justify-center gap-2 rounded-full bg-gold py-3 text-md font-bold text-navy transition hover:bg-gold-dark"
              >
                <UserPlusIcon className="h-5 w-5" />
                Sign Up
              </Link>
            </>
          )}
        </div>

        {/* Version footer, pinned to the bottom of the drawer */}
        <p className="px-5 py-4 text-xs text-center text-gray-500 border-t border-white/10">v1.0</p>
      </div>
    </div>
  );
}

export default MobileNavDrawer;
